import type { IAiModel } from '../state/aiModels'

export const modelInputKinds = (model: IAiModel | null | undefined): string[] => {
    if (Array.isArray(model?.supportedInputs)) return model.supportedInputs
    // Compatibility with cached catalogs; output type does not imply input support.
    return [
        'text',
        ...(model?.canRemixImage ? ['image'] : []),
        ...(model?.canRemixVideo ? ['video'] : []),
        ...(model?.canRemixAudio ? ['audio'] : []),
    ]
}
